import { PRESUPUESTADOR_CLEAR_LEAD_PRESUPUESTADOR } from './constants'
import { HOME_CLEAR_CURRENT_LEAD } from '../../home/redux/constants'

export function clearLeadPresupuestador() {
  return (dispatch) => {
    dispatch({
      type: HOME_CLEAR_CURRENT_LEAD,
    })
    dispatch({
      type: PRESUPUESTADOR_CLEAR_LEAD_PRESUPUESTADOR,
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_CLEAR_LEAD_PRESUPUESTADOR:
      return {
        ...state,
        client_lead_original: null,
        cliente: {
          id_cliente: '',
          nombre: '',
          apellido: '',
          email: '',
          telefono: '',
          tipoDoc: 'DNI',
          documento: '',
        },
      }

    default:
      return state
  }
}
